import { Component } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { GreetingService } from '../servicegreeting/greeting.service';

@Component({
  selector: 'app-welcome-message',
  templateUrl: './welcome-message.component.html',
  styleUrls: ['./welcome-message.component.scss']
})
export class WelcomeMessageComponent {
  greetingData: any;
  constructor(
    private activeModalService: NgbActiveModal,
    private _GreetingService: GreetingService
  ){
    this._GreetingService.watch().valueChanges.subscribe((results:any)=>{
      if((results != undefined)&&(results['data']['queryGreetingPopupContents']?.length>0)){
        this.greetingData = results['data']['queryGreetingPopupContents'][0];
      }
      console.log("greeting martina", this.greetingData)
    })
  }
  CloseModal() {
    this.activeModalService.close()
    
  }
}
